import { shallowEqual, useSelector } from 'react-redux';
import { formatCurrency } from 'syf-js-utilities';
import useSelectedDuplicateTransactions from './useDuplicateTransactions';
var useTotalDisputeAmount = function () {
    var transactionAmount = useSelector(function (_a) {
        var transactionData = _a.transactionData;
        return transactionData;
    }, shallowEqual).transactionAmount;
    var selectedDuplicateTransactions = useSelectedDuplicateTransactions().selectedDuplicateTransactions;
    var totalDuplicateTransactions = selectedDuplicateTransactions.reduce(function (partialSum, _a) {
        var dupTransactionAmount = _a.transactionAmount;
        return partialSum + Number(dupTransactionAmount);
    }, 0);
    var totalAmount = Number(transactionAmount) + totalDuplicateTransactions;
    return formatCurrency(totalAmount);
};
export default useTotalDisputeAmount;
//# sourceMappingURL=useTotalDisputeAmount.js.map